import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import { useState, useEffect } from 'react';
import { FormState } from '../signIn/types';
import SignInModal from '../signInModal';
import { Theme, createStyles } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import { useAuth } from '../../hooks';
import "@fontsource/anton"

interface MyStyles {
    pageContainer: string;
    heading: string;
    button: string;
    image: string;
}
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    pageContainer: {
        paddingTop: theme.spacing(6),
        textAlign: "center"
    },
    heading: {
        fontFamily: "Anton"
    },
    button: {
        width: "200px"
    },
    image: {
        width: "300px"
    }
  })
);

const SplashScreen: React.FunctionComponent = () => {
    const classes = useStyles() as MyStyles;
    const { 
        handleGoogleSignIn,
        isLoading 
    } = useAuth();

    const [signInFormState, setSignInFormState] = useState<FormState | undefined>(undefined);
    const [signingIn, setSigningIn] = useState(false);

    /* Google Sign-In function - Using the auth store */
    const signInWithGoogle = async function() {
        console.log('🚀 Splash Screen - Google button clicked!');
        setSigningIn(true);
        
        try {
            await handleGoogleSignIn();
            console.log('✅ Splash Screen - Google sign-in completed');
        } catch (err: any) {
            console.error('❌ Splash Screen - Google sign-in error:', err);
            setSignInFormState(FormState.SignIn);
        } finally {
            setSigningIn(false);
        }
    }

    return (
        <div className={classes.pageContainer}>
            <Grid
                container
                direction="column"
                spacing={3}
                alignItems="center"
            >
                <Grid item>
                    <img
                        className={classes.image}
                        src={process.env.PUBLIC_URL + '/trading_transparent.png'}
                    /> 
                </Grid>
                <Grid item>
                    <Typography variant="subtitle1">
                        Welcome to
                    </Typography>
                    <br />
                    <Typography variant="h2" className={classes.heading}>
                        Kandi Love
                    </Typography>
                </Grid>
                {signingIn ? (
                    <Grid item>
                        <Grid container direction="column" alignItems="center" spacing={2}>
                            <Grid item>
                                <CircularProgress size={40} />
                            </Grid>
                            <Grid item>
                                <Typography variant="body2" color="textSecondary">
                                    Signing in with Google...
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                ) : (
                    <>
                        <Grid item>
                            <Button
                                className={classes.button}
                                color="primary"
                                variant="contained"
                                onClick={() => setSignInFormState(FormState.SignIn)}
                            >
                                Sign In
                            </Button>
                        </Grid>
                        <Grid item>
                            <Button
                                className={classes.button}
                                color="secondary"
                                variant="contained"
                                onClick={() => {
                                    setSignInFormState(FormState.SignUp)
                                }}
                            >
                                Sign Up
                            </Button>
                        </Grid>
                        <Grid item>
                            <Button
                                className={classes.button}
                                variant="outlined"
                                onClick={signInWithGoogle}
                                startIcon={
                                    <svg width="18" height="18" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                        <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                                        <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                                        <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                                        <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                                    </svg>
                                }
                                sx={{
                                    textTransform: 'none',
                                    '&:hover': {
                                        borderColor: '#4285f4',
                                        backgroundColor: 'rgba(66, 133, 244, 0.04)'
                                    }
                                }}
                            >
                                Sign in with Google
                            </Button>
                        </Grid>
                    </>
                )}
            </Grid>
            <SignInModal
                open={signInFormState ? true : false}
                onClose={() => setSignInFormState(undefined)}
                initialState={signInFormState}
            />
        </div>
    );
}

export default SplashScreen;
